import { render } from "./user_edit.vue?vue&type=template&id=01b3bfc5"
import script from "./user_edit.vue?vue&type=script&lang=js"
export * from "./user_edit.vue?vue&type=script&lang=js"

import "./user_edit.vue?vue&type=style&index=0&id=01b3bfc5&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__